import { TextareaAutosize } from "@mui/material";
import type { TextareaAutosizeProps } from "@mui/material";
import type { CSSProperties } from "react";

interface TextAreaProps extends TextareaAutosizeProps {
  resize?: boolean;
  style?: CSSProperties;
}

export const TextArea = ({ resize, style = {}, ...rest }: TextAreaProps) => {
  return (
    <TextareaAutosize
      className="rounded-lg px-4 py-2 outline-none"
      style={{
        ...(resize ? {} : { resize: "none" }),
        ...style,
      }}
      {...rest}
    />
  );
};
